import { AccreditationInvestorStageEnumType } from '__generated__/graphql';

export default function accreditationInvestorStageToReadable(
  role: AccreditationInvestorStageEnumType
): {
  label: string;
  color: string;
} {
  switch (role) {
    case AccreditationInvestorStageEnumType.AccreditationInitiateProcess:
      return {
        label: 'Initial Email Sent',
        color: 'green',
      };
    case AccreditationInvestorStageEnumType.AccreditationReminder:
      return {
        label: 'Reminder Email Sent',
        color: 'orange',
      };
    default:
      return {
        label: role,
        color: 'gray',
      };
  }
}
